import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export default function useGetSimilarContributors(contributorID, limit) {
  const searchQueryId = window.Livewire?.request?.searchQuery?.id;
  return useAxios({
    cache: { ignoreCache: true },
    url: `/api/v1/contributors/similar_to/contributor/${contributorID}`,
    method: 'GET',
    params: { search_query_id: searchQueryId, top: limit },
  }, { manual: true });
}
